<script setup>
  import visualSubImage from "@/assets/images/visual_sub.png";
  const props = defineProps({
    title: String,
    subTitle: String,
    bgImageUrl: String,
  });
</script>

<template>
  <div
    class="sub-visual"
    :style="{
      backgroundImage: bgImageUrl
        ? `url(${bgImageUrl})`
        : `url(${visualSubImage})`,
      height: props.subTitle ? '200px' : '160px',
    }"
  >
    <h2 class="text-gradient">{{ props.title }}</h2>
    <p v-html="props.subTitle" />
  </div>
</template>

<style lang="scss" scoped>
  .sub-visual {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: var(--smoe-white);
    background-color: var(--smoe-gray-500);
    background-size: cover;
    background-position: center;
    h2 {
      font-size: 40px;
      font-weight: 800;
      line-height: 140%;
    }
    p {
      color: #333;
      font-size: 17px;
      font-weight: 400;
      line-height: 150%;
      strong {
        font-weight: 700;
      }
    }
  }
</style>
